import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IAtRoleState {
    _roles?: string[]
}

const initialState: IAtRoleState = {
    _roles: undefined,
}

export const atRoleSlice = createSlice({
    name: 'atRoleSlice',
    initialState,
    reducers: {
        setRoles: (state, action: PayloadAction<{roles: string[]}>) => {
            state._roles = action.payload.roles
        },
    },
})

export const {
    setRoles,
} = atRoleSlice.actions

export default atRoleSlice.reducer
